/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';
import {

    getAllUsers,
    getUserById, getUserInfo,
    logout, getUsersCount, getUser, getUserFiltred, getUsersInfo
} from "./userAction";

const initialState = {
    data: {},
    status: null,
    user: {},
    userById: {},
    loginned: false,
    usersInfo: {},
    usersCount: {},
    userInfo: {}
}
const userSlice = createSlice({
    name: 'user',
    initialState,
    extraReducers: {

        [logout.fulfilled]: (state, { payload }) => {
            state.user = {};
            state.loginned = false;
        },

        [getAllUsers.fulfilled]: (state, { payload }) => {
            state.usersInfo = payload;
        },
        [getUser.fulfilled]: (state, { payload }) => {
            state.usersInfo = payload;
        },
        [getUser.rejected]: (state, { payload }) => {
            state.usersInfo = {};
        },
        [getUserFiltred.fulfilled]: (state, { payload }) => {
            state.userInfo = payload;
        },
        [getUserById.fulfilled]: (state, { payload }) => {
            state.userById = payload;
        },
        [getUserInfo.fulfilled]: (state, { payload }) => {
            state.user = payload;
            state.loginned = true
        },
        [getUsersInfo.fulfilled]: (state, { payload }) => {
            state.usersInfo = payload;
        },
        [getUsersCount.fulfilled]: (state, { payload }) => {

            state.usersCount = payload;
        },

    }
})

export default userSlice.reducer